import React, { useState } from 'react';
import { Button } from 'antd';
import axios from 'axios';

const TrackFoodButton = ({ foodLogModel, onTrackedItemsChange, messageApi, onTrackSuccess }) => {
  const [loading, setLoading] = useState(false);

  const handleTrack = async () => {
    if (!foodLogModel) {
      messageApi.error("Please enter valid quantity.");
      return;
    }
    setLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/track-foods`,
        foodLogModel,
        { withCredentials: true }
      );
      const trackedItem = response.data;

      onTrackedItemsChange?.((prevList) => {
        const newList = [...(prevList || []), trackedItem];
        return newList;
      });

      messageApi.success(`${trackedItem.foodName || 'Food item'} tracked successfully.`);

      if (onTrackSuccess) {
        onTrackSuccess();  // Notify parent to refresh list & close drawer
      }
    } catch (error) {
      messageApi.error('Failed to track food. Please try again.');
      console.error('Failed to track food:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button type="primary" onClick={handleTrack} loading={loading} disabled={!foodLogModel}>
      Track Food
    </Button>
  );
};

export default TrackFoodButton;
